import { Box, Tooltip, IconButton, SvgIcon, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import useData from './hooks';
import { LogoBox } from './style';
import { LeftItemsProps } from './types';
import { leftItemsName } from './const';
import BackButton from './BackButton';
import { showOnMobile, hideOnMobile } from '20.formLib/sharedStyles';
import { LogoStandardMediumSvg } from '10.quickConnect.app/components/shared/Icons/Logo/Standard/Medium';
import { LeftItemsStyle } from '10.quickConnect.app/components/shared/LayOut/TopBar/style';
import { iconsLogoStyle } from '10.quickConnect.app/components/shared/Icons/Logo/Standard/styles';
import { LogoStandardSmallSvg } from '10.quickConnect.app/components/shared/Icons/Logo/Standard/Small';
import { useWindowSize } from '80.quickConnect.Core/hooks';
import { useStore } from '30.quickConnect.Stores';

const LeftItems: React.FC<LeftItemsProps> = ({ children, showLeftMenuButton, showBackButton }: LeftItemsProps) => {
  const theme = useTheme();
  const { width } = useWindowSize();
  const { t } = useTranslation('common');
  const { goHome, showLeftMenu, setShowLeftMenu } = useData(showLeftMenuButton);

  const {
    LoginStore: { connected, currentOuCode, logoOwner, getUserOrganizationnalUnits },
  } = useStore();

  // Les logos viennent de getcurrentuseravailableouslist: on recharge la liste au montage (refresh) et à chaque changement d'UO
  useEffect(() => {
    if (connected && currentOuCode) void getUserOrganizationnalUnits();
  }, [connected, currentOuCode, getUserOrganizationnalUnits]);

  const logo = logoOwner?.logo ?? null;

  return (
    <Box data-cy={leftItemsName} sx={LeftItemsStyle}>
      {showLeftMenuButton && !showLeftMenu && (
        <IconButton onClick={() => setShowLeftMenu(true)}>
          <MenuRoundedIcon />
        </IconButton>
      )}
      <>
        {showBackButton ? <BackButton /> : <></>}
        <Box sx={showOnMobile}>
          {/* {showBackButton ? <BackButton /> : <MainMobileMenu />} */}
          <Box sx={{ ...LogoBox }}>
            <Tooltip title={t('qcapp_common_home_page').toString()}>
              <Box
                sx={iconsLogoStyle(theme)}
                onClick={goHome}
                onAuxClick={goHome}
                data-cy={`${leftItemsName}-goHome-mobile`}
              >
                {logo ? (
                  <img
                    src={logo}
                    alt="Organization Logo"
                    aria-label={logoOwner?.name}
                    data-cy={`${leftItemsName}-logo`}
                    style={{ height: '32px', width: 'auto' }}
                  />
                ) : (
                  <SvgIcon
                    component={LogoStandardMediumSvg}
                    viewBox="inherit"
                    fontSize="small"
                    data-cy={`${leftItemsName}-logo`}
                  />
                )}
              </Box>
            </Tooltip>
          </Box>
        </Box>
        <Box sx={{ ...hideOnMobile }}>
          <Tooltip title={t('qcapp_common_home_page').toString()}>
            <Box onClick={goHome} onAuxClick={goHome} data-cy={`${leftItemsName}-goHome-desktop`}>
              {logo ? (
                <img
                  src={logo}
                  alt="Organization Logo"
                  aria-label={logoOwner?.name}
                  data-cy={`${leftItemsName}-logo`}
                  style={{ height: '32px', width: 'auto' }}
                />
              ) : (
                <SvgIcon
                  component={
                    width && width > theme.breakpoints.values.lg ? LogoStandardMediumSvg : LogoStandardSmallSvg
                  }
                  viewBox="inherit"
                  fontSize="small"
                  data-cy={`${leftItemsName}-logo`}
                />
              )}
            </Box>
          </Tooltip>
        </Box>
      </>
      <Box sx={{ marginLeft: '1vw' }}>{children}</Box>
    </Box>
  );
};

export default observer(LeftItems);
